export const cssBundleHref = "/build/css-bundle-JTGYEALL.css";